module.exports = __webpack_public_path__ + "static/media/placeholder.bb996a4e.png";